// src/utils/pendingEnrol.js
//
// TrialEnroll (/enroll) is a standalone authed page. A signed-out visitor —
// most often someone clicking the enrol link in a trial_followup email — is
// sent to /login. This marker lets Login send them back to /enroll after
// sign-in, instead of the default course-status landing.
//
// sessionStorage, so it dies with the tab. Only /enroll ever sets it, so
// honouring it in Login changes no other user's landing. Mirrors the
// pendingTrialSignup handoff, minus the payload (the destination is always
// /enroll).

const KEY = 'enrol_return';

export function stashEnrolReturn() {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    /* private mode / storage disabled — best effort */
  }
}

export function readEnrolReturn() {
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function clearEnrolReturn() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
